(() => {
  const selector = '[data-suedlis-imprint]';
  function enhance(root) {
    if (root.dataset.imprintReady === 'true') return;
    const source = root.querySelector('[data-imprint-source]');
    const nav = root.querySelector('[data-imprint-index]');
    const list = root.querySelector('[data-imprint-index-list]');
    if (!source || !nav || !list) return;
    const entries = [];
    const uniqueId = base => {
      let id = base, suffix = 2;
      while (document.getElementById(id)) id = `${base}-${suffix++}`;
      return id;
    };
    const addEntry = (section, heading) => {
      const title = heading.textContent.trim();
      const displayTitle = heading.hasAttribute('data-imprint-decoration') && /^Umsatzsteuer-Identifikationsnummer\s*:/i.test(title)
        ? 'Umsatzsteuer-Identifikationsnummer:'
        : title;
      if (!heading.id) {
        const slug = title.toLocaleLowerCase('de-DE').replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
        heading.id = uniqueId(`impressum-${slug || entries.length + 1}`);
      }
      if (displayTitle !== title) heading.textContent = displayTitle;
      if (/^Umsatzsteuer-Identifikationsnummer\s*:?\s*$/i.test(displayTitle)) {
        const copy = section.querySelector('.suedlis-imprint__section-copy');
        const copyWalker = document.createTreeWalker(copy, NodeFilter.SHOW_TEXT);
        while (copyWalker.nextNode()) {
          const node = copyWalker.currentNode;
          node.textContent = node.textContent.replace(/^(\s*)Umsatzsteuer-Identifikationsnummer\s*:\s*/i, '$1');
        }
      }
      heading.classList.add('suedlis-imprint__section-title');
      heading.tabIndex = -1;
      const number = document.createElement('span');
      number.className = 'suedlis-imprint__section-number';
      number.textContent = String(entries.length + 1).padStart(2, '0');
      number.dataset.imprintDecoration = '';
      number.setAttribute('aria-hidden', 'true');
      section.prepend(number);
      const item = document.createElement('li'), link = document.createElement('a');
      link.href = `#${encodeURIComponent(heading.id)}`;
      link.textContent = displayTitle;
      item.append(link); list.append(item); entries.push({ heading, section });
    };
    const headings = [...source.querySelectorAll('h2,h3')].filter(h => !h.closest('#itkanzlei_txt_copyright'));
    if (headings.length) {
      for (const heading of headings) {
        const nodes = []; let next = heading.nextSibling;
        while (next && !(next.nodeType === 1 && (next.matches('h2,h3') || next.id === 'itkanzlei_txt_copyright'))) { nodes.push(next); next = next.nextSibling; }
        const section = document.createElement('section'); section.className = 'suedlis-imprint__section';
        heading.before(section); section.append(heading);
        const copy = document.createElement('div'); copy.className = 'suedlis-imprint__section-copy'; copy.append(...nodes); section.append(copy);
        addEntry(section, heading);
      }
    } else {
      // IT-Recht supplies this document as line groups separated by two <br> elements.
      // Move every original node; only navigation labels and presentation numbers are added.
      const blocks = [...source.children].filter(el => el.id !== 'itkanzlei_txt_copyright');
      for (const block of blocks) {
        const groups = []; let current = [], breaks = [];
        for (const node of [...block.childNodes]) {
          const meaningful = node.nodeType === 1 && node.tagName !== 'BR' || node.nodeType === 3 && node.textContent.trim();
          if (meaningful && breaks.length >= 2) {
            breaks.forEach(br => br.classList.add('suedlis-imprint__source-gap'));
            groups.push(current); current = []; breaks = [];
          }
          current.push(node);
          if (node.nodeType === 1 && node.tagName === 'BR') breaks.push(node);
          else if (meaningful) breaks = [];
        }
        if (current.length) groups.push(current);
        for (const nodes of groups) {
          const text = nodes.map(n => n.textContent).join('').trim();
          if (!text) continue;
          const section = document.createElement('section'); section.className = 'suedlis-imprint__section';
          nodes[0].before(section);
          const heading = document.createElement('h2'); heading.dataset.imprintDecoration = '';
          if (/E-Mail:|Tel\.:|Telefon:/i.test(text)) heading.textContent = 'Kontakt';
          else if (/Streitbeilegungsverfahren|Verbraucherschlichtungsstelle/i.test(text)) heading.textContent = 'Verbraucherstreitbeilegung';
          else if (/Fairness im Handel/.test(text)) heading.textContent = 'Fairness im Handel';
          else if (entries.length === 0) heading.textContent = 'Anschrift';
          else heading.textContent = text.split('\n').find(s => s.trim())?.trim().slice(0,90) || 'Weitere Angaben';
          const copy = document.createElement('div'); copy.className = 'suedlis-imprint__section-copy'; copy.append(...nodes); section.append(heading, copy);
          addEntry(section, heading);
        }
      }
    }
    // Preserve the source's displayed contact text while making the actual values actionable.
    const walker = document.createTreeWalker(source, NodeFilter.SHOW_TEXT);
    const textNodes = []; while (walker.nextNode()) textNodes.push(walker.currentNode);
    for (const node of textNodes) {
      if (node.parentElement.closest('a,[data-imprint-decoration],#itkanzlei_txt_copyright')) continue;
      const phone = node.textContent.match(/(?:Tel\.:|Telefon:)\s*([+\d][\d ()/-]*\d)/i);
      const email = node.textContent.match(/[\w.+-]+@[\w.-]+\.[a-z]{2,}/i);
      const value = phone?.[1] || email?.[0];
      if (!value) continue;
      const start = node.textContent.indexOf(value), valueNode = node.splitText(start);
      valueNode.splitText(value.length);
      const link = document.createElement('a');
      if (phone) {
        const digits = value.replace(/[^\d+]/g, '');
        link.href = `tel:${digits.startsWith('00') ? '+' + digits.slice(2) : digits.startsWith('0') ? '+49' + digits.slice(1) : digits}`;
      } else link.href = `mailto:${value}`;
      link.dataset.imprintContactLink = '';
      valueNode.before(link); link.append(valueNode);
    }
    if (!entries.length) return;
    const reveal = hash => {
      let id; try { id = decodeURIComponent(hash.replace(/^#/, '')); } catch (_) { return; }
      const target = document.getElementById(id);
      if (!target || !source.contains(target)) return;
      const entry = entries.find(e => e.heading === target || e.section.contains(target));
      if (entry) entry.heading.focus({ preventScroll: true });
      target.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    };
    nav.addEventListener('click', event => {
      const link = event.target.closest('a');
      if (!link || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (location.hash !== link.hash) history.pushState(null, '', link.hash);
      reveal(link.hash);
    });
    nav.hidden = false; root.dataset.imprintReady = 'true';
    window.addEventListener('hashchange', () => reveal(location.hash));
    if (location.hash) reveal(location.hash);
  }
  document.querySelectorAll(selector).forEach(enhance);
  document.addEventListener('shopify:section:load', event => {
    if (event.target.matches(selector)) enhance(event.target);
    event.target.querySelectorAll(selector).forEach(enhance);
  });
})();
